import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

// Don't add NODE_ENV into T3 Env, it changes the tree-shaking behavior
export const Env = createEnv({
  server: {
    AUTH_API_BASE_URL: z.string().optional(),
    PreAuthSecretKey: z.string().optional(),
    JwtSecretKey: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_HOMESITE_URL: z.string().optional(),
    NEXT_PUBLIC_APPLICATION_URL: z.string().optional(),
    NEXT_PUBLIC_TZO_DEVELOPERSITE_URL: z.string().optional(),
    NEXT_PUBLIC_990N_SITE_URL: z.string().optional(),
    NEXT_PUBLIC_2290_SITE_URL: z.string().optional(),
    NEXT_PUBLIC_OWNEROPERATOR_SITE_URL: z.string().optional(),
    NEXT_PUBLIC_AUTOMAGIC_SITE_URL: z.string().optional(),
    NEXT_PUBLIC_SPS_HOMESITE_URL: z.string().optional(),
    NEXT_PUBLIC_SPS_APPLICATION_URL: z.string().optional(),
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: z.string().optional(),

    NEXT_PUBLIC_GTM_ID: z.string().optional(),
    NEXT_PUBLIC_OPENAI_PIXEL_ID: z.string().optional(),
    NEXT_PUBLIC_GOOGLE_ANALYTICS: z.string().optional(),
    NEXT_PUBLIC_GA_UA_ID: z.string().optional(),
    NEXT_PUBLIC_MS_CLARITY_ID: z.string().optional(),
    NEXT_PUBLIC_ENVIRONMENT: z.string().optional(),
    NEXT_PUBLIC_TAX_YEAR: z.string().optional(),
    NEXT_PUBLIC_COOKIE_DOMAIN: z.string().optional(),
    NEXT_PUBLIC_SHOW_LOGGER: z.string().optional(),
  },
  // You need to destructure all the keys manually
  runtimeEnv: {
    NEXT_PUBLIC_HOMESITE_URL: process.env.NEXT_PUBLIC_HOMESITE_URL,
    NEXT_PUBLIC_APPLICATION_URL: process.env.NEXT_PUBLIC_APPLICATION_URL,
    NEXT_PUBLIC_TZO_DEVELOPERSITE_URL:
      process.env.NEXT_PUBLIC_TZO_DEVELOPERSITE_URL,
    NEXT_PUBLIC_990N_SITE_URL: process.env.NEXT_PUBLIC_990N_SITE_URL,
    NEXT_PUBLIC_2290_SITE_URL: process.env.NEXT_PUBLIC_2290_SITE_URL,
    NEXT_PUBLIC_OWNEROPERATOR_SITE_URL:
      process.env.NEXT_PUBLIC_OWNEROPERATOR_SITE_URL,
    NEXT_PUBLIC_AUTOMAGIC_SITE_URL: process.env.NEXT_PUBLIC_AUTOMAGIC_SITE_URL,
    NEXT_PUBLIC_SPS_HOMESITE_URL: process.env.NEXT_PUBLIC_SPS_HOMESITE_URL,
    NEXT_PUBLIC_SPS_APPLICATION_URL:
      process.env.NEXT_PUBLIC_SPS_APPLICATION_URL,
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,

    NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
    NEXT_PUBLIC_GOOGLE_ANALYTICS: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS,
    NEXT_PUBLIC_GA_UA_ID: process.env.NEXT_PUBLIC_GA_UA_ID,
    NEXT_PUBLIC_MS_CLARITY_ID: process.env.NEXT_PUBLIC_MS_CLARITY_ID,
    NEXT_PUBLIC_OPENAI_PIXEL_ID: process.env.NEXT_PUBLIC_OPENAI_PIXEL_ID,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_TAX_YEAR: process.env.NEXT_PUBLIC_TAX_YEAR,
    NEXT_PUBLIC_COOKIE_DOMAIN: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
    NEXT_PUBLIC_SHOW_LOGGER: process.env.NEXT_PUBLIC_SHOW_LOGGER,

    AUTH_API_BASE_URL: process.env.AUTH_API_BASE_URL,
    PreAuthSecretKey: process.env.PreAuthSecretKey,
    JwtSecretKey: process.env.JwtSecretKey,
  },
});
